<mat-card>
    <div *ngIf="show; else loading" class="mt-4">
        <!-- <app-text-filter (searchString)="filterTable($event)"></app-text-filter> -->
        <form [formGroup]="tableFilterForm" class="search__form">
            <mat-form-field class="search__form_field" appearance="outline">
                <mat-label>{{'SHARED.SEARCH_BOX' | translate}}</mat-label>
                <input matInput type="text" formControlName="textFilter" placeholder="{{'invite_search_txt_hint' | translate}}">
                <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="tableFilterForm.controls.textFilter.reset()">
                  <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field class="search__form_field" appearance="outline">
                <mat-label>{{'invite_filter_status' | translate}}</mat-label>
                <mat-select formControlName="statusFilter" multiple>
                    <mat-select-trigger>
                        {{'invite_status.'+ (tableFilterForm.controls.statusFilter.value ? tableFilterForm.controls.statusFilter.value[0] : '') | translate}}
                        <span *ngIf="tableFilterForm.controls.statusFilter.value?.length > 1" class="example-additional-selection">
                          (+{{tableFilterForm.controls.statusFilter.value.length - 1}})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let status of statuses" [value]="status">{{'invite_status.'+status | translate}}</mat-option>
                </mat-select>
            </mat-form-field>
        </form>
        <div *ngIf="dataSource.data?.length > 0; else noItems"  class="table-container">
            <table mat-table matSort [dataSource]="dataSource">
    
                <ng-container [matColumnDef]="displayedColumns[0]">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'TABLE.eventInvitation.'+displayedColumns[0] | translate}} </th>
                    <td mat-cell *matCellDef="let element"> {{ element[displayedColumns[0]] }} </td>
                </ng-container>
    
                <ng-container [matColumnDef]="displayedColumns[1]">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'TABLE.eventInvitation.'+displayedColumns[1] | translate}} </th>
                    <td mat-cell *matCellDef="let element"> 
                        <div *ngIf="displayedColumns[1] == 'personEmailAddresse'; else districtName">
                            <a [href]="'mailto:'+ element.personEmailAddresse" *ngIf="element.personEmailAddresse">{{ element.personEmailAddresse }}</a>
                            <div *ngIf="element.personEmailAddresse == undefined">
                                {{'TABLE.eventInvitation.no_email' | translate}}
                            </div>
                        </div>
                        <ng-template #districtName>
                            {{element.huntingDistrictName}}
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="invitation_link">
                    <th mat-header-cell *matHeaderCellDef> {{'more_options_inv_link' | translate}} </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button matTooltip="{{ 'hint_copy_invitation_link' | translate}}" (click)="getInvitationLink(element); $event.stopPropagation();">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="eventDate">
                    <th mat-header-cell *matHeaderCellDef> {{'TABLE.eventInvitation.eventDate' | translate}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.eventDate | date:'shortDate':undefined:locale}} </td>
                </ng-container>
    
                <ng-container matColumnDef="processingStatus">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'TABLE.eventInvitation.processingStatus' | translate}} </th>
                    <td mat-cell *matCellDef="let element">
                        <div style="display: flex; line-height: 48px; align-items: center;">
                            {{ 'invite_status.'+element.processingStatus | translate }} <mat-icon style="cursor: pointer;" [matMenuTriggerFor]="menu">arrow_drop_down</mat-icon> 
                        </div>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item *ngFor="let st of statuses" (click)="editStatus(element, st)">{{'invite_status.'+st | translate}}</button>
                            <!-- <button mat-menu-item>Item 2</button> -->
                        </mat-menu>
                    </td>
                </ng-container>

                <ng-container matColumnDef="creationDate">
                    <th mat-header-cell *matHeaderCellDef> {{'TABLE.eventInvitation.creationDate' | translate}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.creationDate | date:'short':undefined:locale}} </td>
                </ng-container>

                <ng-container matColumnDef="info">
                    <th mat-header-cell *matHeaderCellDef> {{ 'more_options_info' | translate }} </th>
                    <td mat-cell *matCellDef="let element"> <button mat-icon-button (click)="info(element)">
                        <mat-icon>info</mat-icon>
                    </button> </td>
                </ng-container>
    
                <!-- <ng-container matColumnDef="options">
                    <th mat-header-cell *matHeaderCellDef> {{'TABLE.eventInvitation.options' | translate}} </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="info(element)">{{ 'more_options_info' | translate }}</button>
                            <button mat-menu-item>Item 2</button>
                        </mat-menu>
                    </td>
                </ng-container> -->
    
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr class="clickable" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </div>
    <mat-paginator [hidden]="dataSource?.data?.length < 1" [pageSizeOptions]="paginatorPageSizeOptions">
    </mat-paginator>
    <button mat-raised-button (click)="exportToExcel()" class="third-btn">Excel Export</button>    
</mat-card>

<ng-template #loading>
    Loading...
</ng-template>
<ng-template #noItems>
    No items... 
</ng-template>
